export default "__VITE_ASSET__3eD67qt$__"